// Hook de suivi des statistiques utilisateur (consultations, série, score) en localStorage.
import { useCallback, useEffect, useState } from "react";

const KEY = "pcg2025_stats_v1";

const initial = () => ({
  viewedAccounts: [],     // numéros de comptes consultés (uniques)
  quizResults: [],        // [{id, ok, ts}]
  quizStreak: 0,          // série actuelle de bonnes réponses
  bestStreak: 0,
  exerciceCompletions: [], // [{id, score, total, ts}]
  totalSessionMs: 0,
  firstVisit: Date.now(),
});

export function useStats() {
  const [stats, setStats] = useState(() => {
    try {
      const raw = localStorage.getItem(KEY);
      return raw ? { ...initial(), ...JSON.parse(raw) } : initial();
    } catch (e) {
      console.warn("useStats: corrupt localStorage, using initial state", e);
      return initial();
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(KEY, JSON.stringify(stats));
    } catch (e) {
      console.warn("useStats: failed to persist stats", e);
    }
  }, [stats]);

  const trackView = useCallback((num) => {
    setStats((cur) => {
      if (cur.viewedAccounts.includes(num)) return cur;
      return { ...cur, viewedAccounts: [...cur.viewedAccounts, num] };
    });
  }, []);

  const trackQuiz = useCallback((id, ok) => {
    setStats((cur) => {
      const quizResults = [...cur.quizResults, { id, ok, ts: Date.now() }];
      const quizStreak = ok ? cur.quizStreak + 1 : 0;
      const bestStreak = Math.max(cur.bestStreak, quizStreak);
      return { ...cur, quizResults, quizStreak, bestStreak };
    });
  }, []);

  const trackExercice = useCallback((id, score, total) => {
    setStats((cur) => ({
      ...cur,
      exerciceCompletions: [
        ...cur.exerciceCompletions,
        { id, score, total, ts: Date.now() },
      ],
    }));
  }, []);

  const reset = useCallback(() => setStats(initial()), []);

  return { stats, trackView, trackQuiz, trackExercice, reset };
}
